import React from 'react';
import { Popup } from 'react-mapbox-gl';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { APP_ROUTES } from '../../../constants';
import { useFilter } from '../../../hooks';
import { KMLEntry } from '../../../interfaces';
import { basic } from '../../../theme/colors';
import { MarkerDescription } from './MarkerDescription';
import { updateFilterPartial } from '../../../queries';

const StyledPopup = styled.div`
  background: white;
  color: ${basic.haydenDarkBrand};
  font-weight: 400;
  padding: 5px;
  border-radius: 2px;
`;

const GoToEventsLink = styled.a`
  display: block;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #e0e0e0;
  color: ${basic.haydenBrand};
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: ${basic.haydenDarkBrand};
  }
`;

interface Props {
  lat: number;
  lon: number;
  selectedMarker: KMLEntry | null;
}

export const MapPopup = (props: Props) => {
  const { selectedMarker, lat, lon } = props;
  const history = useHistory();
  const currentFilters = useFilter();

  if (!selectedMarker) {
    return null;
  }

  const handleGoToEvents = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    const busStopId = selectedMarker.bus_stop_id;
    if (!busStopId) {
      return;
    }

    updateFilterPartial({
      ...currentFilters,
      bus_stop_ids: [busStopId], // Replace with only new bus_stop_id
    });
      // Navigate to events list view
      history.push(APP_ROUTES.portalList);
  };

  const showGoToEventsLink = selectedMarker.bus_stop_id && selectedMarker.event_types?.includes('BUS_STOP');

  return (
    <Popup coordinates={[lon, lat]}>
      <StyledPopup>
        <MarkerDescription marker={selectedMarker} />
        {showGoToEventsLink && (
          <GoToEventsLink onClick={handleGoToEvents} data-test="go-to-events-link">
            Go to events →
          </GoToEventsLink>
        )}
      </StyledPopup>
    </Popup>
  );
};
